interface Props {
  primaryTopic: string;
  isControversial: boolean;
  categoryScores: Record<string, number>;
}

export default function TopicBars({
  primaryTopic,
  isControversial,
  categoryScores,
}: Props) {
  // Apollo stamps `__typename` onto every object; drop it (and any non-numeric
  // key) before charting — otherwise it renders a "Typename — NaN%" row and its
  // string value poisons `max`, which collapses every bar to full width.
  const rows = Object.entries(categoryScores)
    .filter(
      ([k, v]) =>
        k !== '__typename' && typeof v === 'number' && Number.isFinite(v),
    )
    .map(([k, v]) => ({ label: k.replace(/_/g, ' '), value: v }))
    .sort((a, b) => b.value - a.value);
  const max = Math.max(...rows.map((r) => r.value), 1);

  // Inner content only; SectionShell supplies the `topic` anchor + eyebrow.
  return (
    <div className="POST__ANALYSIS__topic">
      <div className="POST__ANALYSIS__topic__head">
        <span className="POST__ANALYSIS__pill">
          {primaryTopic.replace(/_/g, ' ')}
        </span>
        {isControversial && (
          <span className="POST__ANALYSIS__pill pill-negative">
            Controversial
          </span>
        )}
      </div>
      <ul className="POST__ANALYSIS__topic__bars">
        {rows.map((r) => (
          <li key={r.label}>
            <span className="POST__ANALYSIS__topic__label">{r.label}</span>
            <span className="POST__ANALYSIS__topic__track">
              <span
                className="POST__ANALYSIS__topic__fill"
                style={{ width: `${(r.value / max) * 100}%` }}
              />
            </span>
            <span className="POST__ANALYSIS__topic__val">
              {Math.round(r.value * 100)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
